module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home",
    staticClass: "home"
  }, [_c('img', {
    attrs: {
      "src": "https://cdn.yxvzb.com/html/AnswerGold/%E5%BC%80%E5%A7%8B%E9%A1%B5-%E5%BA%95@2x.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bt_box"
  }, [_c('x-button', {
    staticClass: "start",
    nativeOn: {
      "click": function($event) {
        return _vm.jump('play')
      }
    }
  }, [_vm._v("开始答题")]), _vm._v(" "), _c('div', {
    staticClass: "bt_bottom_div"
  }, [_c('x-button', {
    staticClass: "guide currency_home",
    nativeOn: {
      "click": function($event) {
        return _vm.showCoverAction({
          show: true,
          type: 1
        })
      }
    }
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('x-button', {
    staticClass: "redpacket currency_home",
    nativeOn: {
      "click": function($event) {
        return _vm.jump('hb')
      }
    }
  }, [_vm._v("我的红包")])], 1), _vm._v(" "), _c('p', [_vm._v("如需帮助，请在“医学V视界”公众号留言")])], 1), _vm._v(" "), _c('guide-cover')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_text"
  }, [_c('p', [_vm._v("连对四题，即可凑齐拼图拆现金红包")]), _vm._v(" "), _c('p', [_vm._v("更有机会获得友情红包，可转赠好友")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c448fe58"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/Home/index.vue
// module id = 245
// module chunks = 1